import { useMemo } from "react";
import CompanyService from "../../../../services/CompanyService";
import { TranslationService } from "../../../../services/TranslationService";
import Dropdown from "../../../shared/components/Dropdown";
import { ValidationMessage } from "../../../shared/RequieredManager";
import { EditProps, numEvent } from "../EditAction";
import { Field } from "./FieldHelpers";
import { NumberInput } from "../../../shared/components/Editors";

export const TaskDescription = ({ propGen, data }: EditProps) => (
  <div className="row">
    <Field title={TranslationService.translate.Description} colClass="col-9">
      <textarea
        className="form-control"
        onChange={(e) =>
          propGen.str.required("Content").onChange(e.target.value)
        }
        value={data.Content}
        style={{ resize: "none" }}
        rows={6}
        spellCheck={false}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        data-gramm="false"
        data-gramm_editor="false"
        data-enable-grammarly="false"
        translate="no"
      />
      <ValidationMessage
        {...propGen.str.required("Content")}
        message={TranslationService.translate.EnterTask}
      />
    </Field>
  </div>
);

export const TaskDue = ({ propGen }: EditProps) => (
  <div className="row">
    <Field title={TranslationService.translate.Expiration}>
      <div className="d-flex align-items-center gap-3">
        <NumberInput
          className="form-control"
          {...numEvent(propGen.num.required("Task_Due"))}
        />
        <label>{TranslationService.translate.Days}</label>
      </div>
      <ValidationMessage
        {...propGen.num.required("Task_Due")}
        message={TranslationService.translate.EnterDue}
      />
    </Field>
  </div>
);

export const TaskResponsableValidator = ({
  propGen,
  data,
  setField
}: EditProps) => {
  const users = useMemo(
    () =>
      CompanyService.getUsers().map((x) => ({
        text: x.Value,
        value: parseInt(x.Id)
      })),
    []
  );
  const responsibleUsers = useMemo(
    () => [
      { text: TranslationService.translate.TheUser, value: -1 },
      { text: TranslationService.translate.NotAssigned, value: null as any },
      ...users
    ],
    [users]
  );
  const validatorUsers = useMemo(
    () => [
      { text: TranslationService.translate.NotAssigned, value: null as any },
      ...users
    ],
    [users]
  );
  const responsibleProps = propGen.num.notRequired("Task_ResponsibleUserID");
  const validatorProps = propGen.num.notRequired("Task_ValidatorUserID");

  // Calcular el valor a mostrar según Task_ResponsibleType
  const responsibleValue = useMemo(() => {
    if (data.Task_ResponsibleType === 1) {
      return -1;
    } else if (data.Task_ResponsibleType === 0) {
      // Task_ResponsibleType === 0: usar Task_ResponsibleUserID o null
      if (
        data.Task_ResponsibleUserID === null ||
        data.Task_ResponsibleUserID === undefined
      ) {
        return null;
      }
      return data.Task_ResponsibleUserID;
    } else {
      // Task_ResponsibleType === undefined (nueva tarea): mostrar "El usuario" por defecto
      return -1;
    }
  }, [data.Task_ResponsibleType, data.Task_ResponsibleUserID]);

  const handleResponsibleChange = (value: number | null) => {
    if (value === -1) {
      // Si selecciona "El usuario", establecer Task_ResponsibleType = 1
      setField("Task_ResponsibleType")(1);
      responsibleProps.onChange(-1);
    } else {
      // Si selecciona otra opción, establecer Task_ResponsibleType = 0
      setField("Task_ResponsibleType")(0);
      responsibleProps.onChange(value === null ? undefined : value);
    }
  };
  console.log(CompanyService.getSetting("taskvalidator"));
  return (
    <div className="row">
      <Field title={TranslationService.translate.Responsible}>
        <Dropdown
          items={responsibleUsers}
          defaultValue={responsibleValue}
          onChange={handleResponsibleChange}
        />
      </Field>
      {CompanyService.getSetting("enabletaskvalidator") && (
        <Field title={TranslationService.translate.Validator}>
          <Dropdown
            items={validatorUsers}
            defaultValue={data.Task_ValidatorUserID ?? null}
            onChange={(value: number | null) => {
              validatorProps.onChange(value === null ? undefined : value);
            }}
          />
        </Field>
      )}
    </div>
  );
};
